/* eslint-disable sort-keys-fix/sort-keys-fix */
export default {
  general: {
    button: {
      back: 'Zurück',
    },
  },
  sidebar: {
    title: 'Mein E-Assistent',
    expand: 'Sidebar ausklappen',
    collapse: 'Sidebar einklappen',
  },
  assistants: {
    emobilityInterest: 'Elektro-<br>Mobilität',
    solarRoofShape: 'Solar',
    heatingType: 'Wärme',
    combiInterest: 'Kombi-<br>Lösung',
  },
  mail: {
    subject: 'Anfrage vom Assistenten',
  },
  wallboxes: {
    title: 'Wallboxen',
    step: {
      label: 'Wallboxen',
    },
    description:
      'Vielen Dank für Ihre Anfrage. Die für Sie am besten geeignete Wallbox werden wir gemeinsam mit Ihnen ermitteln. Hier können Sie sich jedoch schon einmal einen Überblick über mögliche Wallboxmodelle verschaffen.',
    loadingError: 'Produkte konnten nicht geladen werden.',
    loadingMessage: 'Produkte werden geladen …',
    noProductsFound:
      'Leider gibt es keine Produkte, die Ihren Kriterien entsprechen.',
    moreInformation: 'Weitere Informationen',
    modal: {
      button: {
        close: 'Schließen',
      },
      details: {
        general: {
          label: 'Allgemein',
          chargingPowerConfigurable: 'Ladeleistung konfigurierbar',
          electricCurrentConfigurable: 'Stromstärke konfigurierbar',
        },
      },
      extras: {
        label: 'Extras',
      },
      chargingPoints: {
        label: 'Ladepunkte',
      },
      dimensions: {
        label: 'Produktmaße',
        width: 'Breite',
        height: 'Höhe',
        length: 'Länge',
        weight: 'Gewicht',
      },
    },
  },
  group: {
    product: 'Produkte',
    heater: 'Heizung',
    power: 'Strom',
    household: 'Haushalt',
    object: 'Objekt',
    other: 'Sonstiges',
    contact: 'Kontakt',
  },
  privacy:
    'Wir verarbeiten Ihre Kontaktangaben auf Ihre Anfrage hin zum Zwecke der Erstellung eines kostenlosen und unverbindlichen Angebots. Weitere Informationen finden Sie in unserer <a href="https://www.stawag.de/datenschutz/" target="_blank">Datenschutzerklärung</a>, deren Inhalt Sie zur Kenntnis genommen haben.',
  sentSuccessfully: {
    title: 'Vielen Dank!',
    text: 'Wir melden uns baldmöglichst. Sie erhalten eine E-Mail an die von Ihnen angegebene E-Mail-Adresse',
  },
  heatOrCombi: {
    title: 'Wofür interessieren Sie sich?',
    step: {
      label: 'Interesse',
    },
    formFields: {
      interest: {
        formattedLabel: 'Interesse',
        options: {
          heating: {
            label: 'Wärmelösung',
            description:
              'Ich interessiere mich ausschließlich für eine neue Wärmelösung.',
          },
          combi: {
            label: 'Kombilösung',
            description:
              'Ich interessiere mich für eine Wärmelösung in Kombination mit weiteren Energielösungen, z. B. Photovoltaik, Speicher und/oder Wallbox.',
          },
        },
      },
    },
  },
  emobilityInterest: {
    title: 'Wofür interessieren Sie sich?',
    step: {
      label: 'Interesse',
    },
    formFields: {
      interest: {
        formattedLabel: 'Interesse',
        options: {
          buy: {
            label: 'Neue Wallbox kaufen',
            description: '(mit und ohne Installation)',
          },
          check: {
            label: 'Installationscheck für Wallboxen',
            htmlLabel:
              'Installationscheck für Wallboxen<span class="gc-text-primary gc-text-xl gc-leading-none">*</span>',
            description: '',
          },
        },
      },
    },
    installCheckHint:
      'Nur im Postleitzahlengebiet 52xxx möglich.<br>Die Erstellung eines individuellen Installationsangebots durch einen Elektrofachbetrieb berechnen wir mit 49 €.<br>Bei Beauftragung der Installation wird dieser Betrag angerechnet.',
  },
  emobilityBuy: {
    title: 'Neue Wallbox kaufen',
    button: {
      allProducts: 'Zu allen Produkten',
    },
    products: {
      desc: 'Sie sind auf der Suche nach einer passenden Wallbox? Werden Sie in unserem Produktsortiment fündig.',
      top: 'Top Produkte',
      wallboxHint: 'Alle Wallboxen sind mit oder ohne Installation erhältlich.',
      button: {
        allProducts: 'Zu allen Produkten',
      },
    },
    consultation: {
      header: 'Fragen zur E-Mobilität?',
      text: 'Sie erreichen uns Montag bis Freitag telefonisch von 10 bis 13 Uhr und von 14 bis 17 Uhr.',
    },
  },
  solarRoofShape: {
    title: 'Angaben zu Ihrer Photovoitalk-Anlage',
    step: {
      label: 'Dachform',
    },
    formFields: {
      roofShape: {
        label: 'Dachform Ihres Hauses',
        formattedLabel: 'Dachform',
        helper:
          'Der Neigungswinkel des Daches beeinflusst die Menge an Strom, die Ihre Photovoltaik-Anlage produziert.',
        options: {
          'flat-roof': { label: 'Flachdach' },
          'pitched-roof': { label: 'Schrägdach' },
          'peaked-roof': { label: 'Spitzdach' },
        },
      },
    },
  },
  solarRoofDirection: {
    title: 'Angaben zu Ihrer Photovoitalk-Anlage',
    step: {
      label: 'Dachausrichtung',
    },
    formFields: {
      roofDirection: {
        label: 'Ausrichtung Ihres Daches',
        formattedLabel: 'Dachausrichtung',
        helper:
          'Die Dachausrichtung beeinflusst die Anzahl an Sonnenstunden, denen Ihre Photovoltaik-Anlage ausgesetzt ist.',
        options: {
          west: { label: 'West' },
          southwest: { label: 'SW' },
          south: { label: 'Süd' },
          southeast: { label: 'SO' },
          east: { label: 'Ost' },
        },
      },
    },
  },
  solarPowerUsage: {
    title: 'Angaben zu Ihrer Photovoitalk-Anlage',
    step: {
      label: 'Stromverbrauch',
    },
    formFields: {
      personCount: {
        label: 'Anzahl Personen',
        helper:
          'Die Anzahl der in Ihrem Haushalt lebenden Personen beeinflusst die Strommenge, die Sie durchschnittlich verbrauchen.',
        options: {
          1: { label: '1' },
          2: { label: '2' },
          3: { label: '3' },
          4: { label: '4' },
          '5+': { label: '5+' },
        },
      },
      powerUsage: {
        label: 'oder genauer Stromverbrauch:',
        formattedLabel: 'Stromverbrauch',
        suffix: 'kWh',
      },
    },
  },
  solarOffer: {
    title: 'Angaben zu Ihrer Photovoitalk-Anlage',
  },
  heatingType: {
    label: 'Angaben zu Ihrer Heizung',
    step: {
      label: 'Heizart',
    },
    formFields: {
      currentHeating: {
        label: 'Womit heizen Sie aktuell?',
        options: {
          electricity: {
            label: 'Strom',
          },
          gas: {
            label: 'Gas',
          },
          oil: {
            label: 'Öl',
          },
          other: {
            label: 'Sonstiges',
          },
        },
        title: 'Aktueller Brennstoff',
      },
    },
  },
  heatingUsage: {
    label: 'Angaben zu Ihrer Heizung',
    step: {
      label: 'Nutzung',
    },
    formFields: {
      currentUse: {
        label: 'Wie wird die Heizung aktuell genutzt?',
        helper: 'lorem ipsum text',
        options: {
          heatHotwater: {
            label: 'Raumwärme und Warmwasser',
          },
          spaceHeating: {
            label: 'Nur Raumwärme',
          },
          storageHeating: {
            label: 'Speicherheizung',
          },
        },
        title: 'Nutzung',
      },
    },
  },
  heatingDistribution: {
    label: 'Angaben zu Ihrer Heizung',
    step: {
      label: 'Wärmeverteiler',
    },
    formFields: {
      distribution: {
        label: 'Welchen Wärmeverteiler haben Sie?',
        helper: 'lorem ipsum text',
        options: {
          radiator: {
            label: 'Heizkörper',
          },
          underfloorHeating: {
            label: 'Fußbodenheizung',
          },
        },
        title: 'Wärmeverteiler',
      },
    },
  },
  heatingConstructionYear: {
    label: 'Angaben zu Ihrer Heizung',
    step: {
      label: 'Baujahr',
    },
    formFields: {
      constructionYear: {
        customOption: 'Genaues Jahr',
        label: 'Baujahr oder letzte energetische Modernisierung?',
        options: {
          '1980': {
            label: 'von / vor 1980',
          },
          '2000': {
            label: 'um 2000',
          },
          today: {
            label: 'bis heute',
          },
        },
        title: 'Baujahr',
      },
    },
  },
  heatingBuildingType: {
    label: 'Angaben zu Ihrer Heizung',
    step: {
      label: 'Gebäudetyp',
    },
    formFields: {
      buildingType: {
        label: 'Um welche Gebäudeart handelt es sich?',
        options: {
          apartment: {
            label: 'Etagenwohnung',
          },
          multiFamily: {
            label: 'Mehrfamilienhaus',
          },
          other: {
            label: 'Sonstiges',
          },
          singleFamily: {
            label: 'Einfamilienhaus',
          },
        },
        title: 'Gebäudetyp',
      },
    },
  },
  heatingInterest: {
    label: 'Angaben zu Ihrer Heizung',
    step: {
      label: 'Heizung',
    },
    formFields: {
      heatingInterest: {
        label: 'Für welches Produkt interessieren Sie sich?',
        options: {
          'heat-pump': {
            label: 'Wärmepumpe',
          },
          hybrid: {
            label: 'Hybridheizung',
          },
          gas: {
            label: 'Gasheizung',
          },
          storage: {
            label: 'Speicherheizung',
          },
        },
        title: 'Heizung',
      },
    },
  },
  combiInterest: {
    step: {
      label: 'Interesse',
    },
    formFields: {
      combiInterest: {
        label: 'Wofür interessieren Sie sich?',
        helper: 'Hinweis: Mehrfachauswahl ist möglich.',
        options: {
          pv: {
            label: 'Photovoltaik',
          },
          storage: {
            label: 'Stromspeicher',
          },
          'heat-pump': {
            label: 'Wärmepumpe',
          },
          wallbox: {
            label: 'Wallbox',
          },
        },
        title: 'Interesse',
      },
    },
  },
  combiHousingSituation: {
    step: {
      label: 'Wohnsituation',
    },
    formFields: {
      housingSituation: {
        label: 'Wie wohnen Sie?',
        options: {
          ownHouse: {
            label: 'Eigenes Haus',
          },
          planning: {
            label: 'Haus in Planung oder Kauf',
          },
          rent: {
            label: 'Miete',
          },
        },
        title: 'Wohnsituation',
      },
    },
  },
  combiInitialSituation: {
    step: {
      label: 'Ausgangssituation',
    },
    formFields: {
      initialSituation: {
        label: 'Haben Sie bereits etwas davon?',
        options: {
          no: {
            label: 'Nein, ich starte neu',
          },
          partially: {
            label: 'Teilweise vorhanden',
          },
          yes: {
            label: 'Bereits gut ausgestattet',
          },
        },
        title: 'Ausgangssituation',
      },
    },
  },
  combiRoof: {
    title: 'Dachform und Dachausrichtung Ihres Hauses',
    step: {
      label: 'Dachform/-ausrichtung',
    },
    formFields: {
      roofShape: {
        label: 'Dachform Ihres Hauses',
        formattedLabel: 'Dachform',
        helper:
          'Der Neigungswinkel des Daches beeinflusst die Menge an Strom, die Ihre Photovoltaik-Anlage produziert.',
        options: {
          'flat-roof': { label: 'Flachdach' },
          'pitched-roof': { label: 'Schrägdach' },
          'peaked-roof': { label: 'Spitzdach' },
        },
      },
      roofDirection: {
        label: 'Ausrichtung Ihres Daches',
        formattedLabel: 'Dachausrichtung',
        helper:
          'Die Dachausrichtung beeinflusst die Anzahl an Sonnenstunden, denen Ihre Photovoltaik-Anlage ausgesetzt ist.',
        options: {
          west: { label: 'West' },
          southwest: { label: 'SW' },
          south: { label: 'Süd' },
          southeast: { label: 'SO' },
          east: { label: 'Ost' },
        },
      },
    },
  },
  combiHeating: {
    label: 'Angaben zu Ihrer Heizung',
    step: {
      label: 'Heizart/Nutzung/Wärmeverteiler',
    },
    formFields: {
      heatingType: {
        label: 'Womit heizen Sie aktuell?',
        options: {
          electricity: {
            label: 'Strom',
          },
          gas: {
            label: 'Gas',
          },
          oil: {
            label: 'Öl',
          },
          other: {
            label: 'Sonstiges',
          },
        },
        title: 'Aktueller Brennstoff',
      },
      currentUse: {
        label: 'Wie wird die Heizung aktuell genutzt?',
        helper: 'lorem ipsum text',
        options: {
          heatHotwater: {
            label: 'Raumwärme und Warmwasser',
          },
          spaceHeating: {
            label: 'Nur Raumwärme',
          },
          storageHeating: {
            label: 'Speicherheizung',
          },
        },
        title: 'Nutzung',
      },
      distribution: {
        label: 'Welchen Wärmeverteiler haben Sie?',
        helper: 'lorem ipsum text',
        options: {
          radiator: {
            label: 'Heizkörper',
          },
          underfloorHeating: {
            label: 'Fußbodenheizung',
          },
        },
        title: 'Wärmeverteiler',
      },
    },
  },
  assistantSubmit: {
    title: 'Ihre persönlichen Daten',
    emobility: {
      title: 'E-Mobilität',
      subtitle:
        'Gerne setzen wir uns für eine persönliche Beratung mit Ihnen in Verbindung. Füllen Sie dazu bitte folgendes Fomular aus.',
    },
    solar: {
      title: 'Solar',
      subtitle:
        'Gerne möchten wir Ihnen nun ihr persönliches Angebot zu Ihrer Auswahl senden. Füllen Sie dazu bitte noch folgendes Fomular aus.',
    },
    heating: {
      title: 'Wärme',
      subtitle:
        'Gerne möchten wir Ihnen nun ihr persönliches Angebot zu Ihrer Auswahl senden. Füllen Sie dazu bitte noch folgendes Fomular aus.',
    },
    combi: {
      title: 'Kombi-Lösung',
      subtitle:
        'Gerne möchten wir Ihnen nun ihr persönliches Angebot zu Ihrer Auswahl senden. Füllen Sie dazu bitte noch folgendes Fomular aus.',
    },
    step: {
      label: 'Kontaktformular',
    },
    formFields: {
      salutation: {
        label: 'Anrede',
        options: {
          w: { label: 'Frau' },
          m: { label: 'Herr' },
        },
      },
      firstname: {
        label: 'Vorname',
      },
      lastname: {
        label: 'Nachname',
      },
      street: {
        label: 'Straße',
      },
      streetNumber: {
        label: 'Hausnr.',
      },
      zipcode: {
        label: 'PLZ',
      },
      city: {
        label: 'Ort',
      },
      phone: {
        label: 'Telefonnummer',
      },
      email: {
        label: 'E-Mail',
      },
      invoiceAddressDiffers: {
        label: 'Weicht die Rechnungsadresse von der Lieferadresse ab?',
        formattedLabel: 'Rechnungsadresse abweichend',
        options: {
          yes: {
            label: 'Ja',
          },
          no: {
            label: 'Nein',
          },
        },
      },
      invoiceAddressLabel: {
        label: 'Bitte geben Sie die abweichende Rechnungsadresse ein:',
      },
      invoiceAddressStreet: {
        label: 'Straße',
      },
      invoiceAddressStreetNumber: {
        label: 'Hausnr.',
      },
      invoiceAddressZipcode: {
        label: 'PLZ',
      },
      invoiceAddressCity: {
        label: 'Stadt',
      },
      note: {
        label: 'Kommentar',
      },
      buildingType: {
        label:
          'In/An welcher Art von Haus soll die Wallbox installiert werden?*',
        formattedLabel: 'Gebäudetyp',
        options: {
          single: { label: 'Einfamilienhaus' },
          'semi-detached': { label: 'Doppelhaushälfte' },
          townhouse: { label: 'Reihenhaus' },
          multi: { label: 'Mehrfamilienhaus / Wohnung / Andere' },
        },
      },
      buildingTypeSingleOrFamily: {
        label: 'Um welche Gebäudeart handelt es sich?',
        formattedLabel: 'Gebäudetyp',
        options: {
          singleFamily: { label: 'Einfamilienhaus' },
          multiFamily: { label: 'Mehrfamilienhaus' },
        },
      },
      owner: {
        label: 'Sind Sie der Eigentümer?',
        formattedLabel: 'Eigentümer',
        options: {
          yes: { label: 'Ja' },
          no: { label: 'Nein' },
        },
      },
      usage: {
        label: 'Wie wird das Gebäude genutzt?',
        formattedLabel: 'Nutzung',
        options: {
          private: { label: 'privat' },
          commercial: { label: 'gewerblich' },
        },
      },
      solarRoofShape: {
        label: 'Ich habe außerdem Interessse an',
        formattedLabel: 'Intresse an',
        options: {
          storage: { label: 'einer Speicherbatterie' },
          wallbox: { label: 'einer Wallbox' },
          heatPump: { label: 'einer Wärmepumpe' },
        },
      },
      consentContact: {
        label: 'Kontaktaufnahme',
        component: {
          label:
            'Wir bieten aktuell nur Lösungen für private Eigentümer von Einfamilien- und Mehrfamilienhäusern an. Ich bin einverstanden, dass STAWAG mich kontaktiert, sobald neue Angebote verfügbar sind',
        },
      },
      referral: {
        label: 'Wie sind Sie auf uns aufmerksam geworden?',
        formattedLabel: 'Aufmerksam geworden durch',
        options: {
          'personal-visit': { label: 'Persönlicher Besuch' },
          'promotion-internet': { label: 'Werbung im Internet' },
          'promotion-facebook': { label: 'Empfehlung durch Bekannte' },
          advertisement: { label: 'Anzeigen (z.B. Zeitung)' },
          recommendation: { label: 'Empfehlung durch Handwerksbetrieb' },
          'e-store': { label: 'E-Store' },
          fair: { label: 'Messen / Veranstaltungen' },
          canvasser: { label: 'Ansprache durch Akquisieur' },
          'invoice-inclosure': { label: 'Rechnungsbeileger' },
        },
      },
    },
  },
};
/* eslint-enable sort-keys-fix/sort-keys-fix */
